import React from "react";
import * as Icon from "react-feather";
let navConfigDonor = [
  {
    type: "item",
    title: "Supplies",
    navLink: "/supplies",
    icon: <Icon.Layout size={20} />,
  },
  {
    type: "item",
    title: "New Supply",
    navLink: "/new-supply",
    icon: <Icon.LogIn size={20} />,
  },
];

export default navConfigDonor;
